import Vue from "vue";

export const store = Vue.observable({
  service: null,
  date: null,
  hour: null,
  name: null,
  phone: null,
  completed: false
});

export const mutations = {
  setService(obj) {
    store.service = obj;
  },
  setDate(date) {
    store.date = date;
  },
  setHour(hour) {
    store.hour = hour;
  },
  setName(name) {
    store.name = name;
  },
  setPhone(phone) {
    store.phone= phone;
  },
  setCompleted($boolean) {
    store.completed = $boolean;
  }
};